export const BLOG_STATUSES = [
  { value: 'draft', label: 'Borrador' },
  { value: 'published', label: 'Publicado' },
  { value: 'archived', label: 'Archivado' },
];

export const MAX_IMAGES_PER_POST = 5;

// Límite del backend para el tamaño total del formulario multipart (32 MiB).
export const MAX_UPLOAD_BYTES = 32 * 1024 * 1024;

export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

export const blogStatusLabel = (status) => {
  const item = BLOG_STATUSES.find((entry) => entry.value === status);
  return item ? item.label : status || '-';
};

export const blogStatusClass = (status) => {
  const classes = {
    draft: 'bg-gray-100 text-gray-700',
    published: 'bg-green-100 text-green-800',
    archived: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-200',
  };
  return classes[status] || 'bg-gray-100 text-gray-700';
};

/**
 * URL absoluta de una variante de imagen. Si el backend devuelve una ruta relativa
 * se resuelve contra la URL base de la API.
 */
export const resolveImageUrl = (url) => {
  if (!url) return '';
  if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:') || url.startsWith('blob:')) return url;
  const base = (process.env.VUE_APP_BASE_URL || '').replace(/\/+$/, '');
  return `${base}${url.startsWith('/') ? '' : '/'}${url}`;
};

/** Slug con el formato que exige la API: ^[a-z0-9]+(-[a-z0-9]+)*$ */
export const slugify = (text) =>
  (text || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const SLUG_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;

/** "4 de marzo de 2026, 18:06" */
export const formatDateTime = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString('es-AR', { dateStyle: 'long', timeStyle: 'short', hour12: false });
};

/** Mensaje de error legible a partir de una respuesta de axios. */
export const apiErrorMessage = (error, fallback = 'Ocurrió un error inesperado.') =>
  error?.response?.data?.message || error?.response?.data?.error || fallback;
